/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpdateLabelRequestLabel
 */
export interface UpdateLabelRequestLabel {
  /**
   *
   * @type {string}
   * @memberof UpdateLabelRequestLabel
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof UpdateLabelRequestLabel
   */
  color?: string
}

export function UpdateLabelRequestLabelFromJSON(json: any): UpdateLabelRequestLabel {
  return UpdateLabelRequestLabelFromJSONTyped(json, false)
}

export function UpdateLabelRequestLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLabelRequestLabel {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    color: !exists(json, 'color') ? undefined : json['color']
  }
}

export function UpdateLabelRequestLabelToJSON(value?: UpdateLabelRequestLabel | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    color: value.color
  }
}
